import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Icon } from 'ui';
import { AgGridReact } from 'ag-grid-react';
import { useSelector } from 'react-redux';
import useDeepCompareEffect from 'use-deep-compare-effect';
import { injectIntl } from 'react-intl';
import styled from 'styled-components';
import DetailsCount from './details-count';

const StyledDiv = styled.div`
  height: ${p => p.height}px !important;
`;

const StyledIcon = styled(Icon)`
  margin-right: 3px;
  color: black;
`;

const TypeRow = styled.div`
  height: 30px !important;
  width: 100%;
  margin-left: 55px;
  background-color: #F8F8F8;
  padding: ${p => !p.canCollapse ? '5px 17px' : '5px'};
  font-weight: 600;
`;

const SmartActionCellRenderer = ({ detailGridOptions, data, canCollapse = false, intl }) => {
  const [collapsedTables, setCollapsedTables] = useState([]);
  const [options, setOptions] = useState([]);
  const childColumnDetails = useSelector(state =>
    state.worklist.childColumnDetails || [],
  );

  const types = detailGridOptions?.childTableIds?.filter(c =>
    data.children?.find(d => d.type?.toLowerCase() === c.id?.toLowerCase()),
  ) || [];

  useDeepCompareEffect(() => {
    setOptions(types.reduce((tot, cur) => ({
      ...tot,
      [cur.id]: {
        ...detailGridOptions,
        columnDefs: childColumnDetails?.filter(c => c.tableId === cur.id),
      },
    }), {}));
  }, [childColumnDetails]);

  const handleClick = (id) => {
    if (collapsedTables?.find(t => t === id)) {
      setCollapsedTables(c => c?.filter(t => t !== id));
    } else {
      setCollapsedTables(c => [
        ...c,
        id,
      ]);
    }
  };

  return (
    <>
      <DetailsCount count={data?.children?.length} total={data?.totalChildrenCount} />
      {types?.map((ct) => {
        const rowData = data.children?.filter(c => c.type === ct.id);
        const isCollapsed = collapsedTables?.find(t => t === ct.id);
        const height = isCollapsed ? 0 : (rowData.length + 1) * 30;
        return (
          <>
            <TypeRow canCollapse={canCollapse}>
              {canCollapse ? <StyledIcon
                type={`chevron-${isCollapsed ? 'right' : 'down'}`}
                onClick={() => handleClick(ct.id)}
              /> : null}
              <span>
                {`${intl.formatMessage({ id: 'tickets.actions.smart_action' })}: ${ct.description}`}
              </span>
            </TypeRow>
            <StyledDiv
              key={ct}
              height={height}
            >
              <AgGridReact
                {...options[ct.id]}
                rowData={rowData}
                className='ag-details-grid'
              />
            </StyledDiv>
          </>
        );
      },
      )}
    </>
  );
};
SmartActionCellRenderer.propTypes = {
  detailGridOptions: PropTypes.object,
  data: PropTypes.object,
  canCollapse: PropTypes.bool,
  intl: PropTypes.object,
};

export default injectIntl(SmartActionCellRenderer);
